/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";

export type V1EnvironmentsListEnvironmentVariablesRequestBody = {
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  project: string;
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  app: string;
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  environment: string;
  /**
   * Maximum number of variables to return per request.
   */
  limit?: number | undefined;
  /**
   * Pagination cursor from a previous response to fetch the next page.
   *
   * @remarks
   * Use when `hasMore: true` in the previous response.
   */
  cursor?: string | undefined;
};

/** @internal */
export type V1EnvironmentsListEnvironmentVariablesRequestBody$Outbound = {
  project: string;
  app: string;
  environment: string;
  limit: number;
  cursor?: string | undefined;
};

/** @internal */
export const V1EnvironmentsListEnvironmentVariablesRequestBody$outboundSchema:
  z.ZodType<
    V1EnvironmentsListEnvironmentVariablesRequestBody$Outbound,
    z.ZodTypeDef,
    V1EnvironmentsListEnvironmentVariablesRequestBody
  > = z.object({
    project: z.string(),
    app: z.string(),
    environment: z.string(),
    limit: z.number().int().default(100),
    cursor: z.string().optional(),
  });

export function v1EnvironmentsListEnvironmentVariablesRequestBodyToJSON(
  v1EnvironmentsListEnvironmentVariablesRequestBody:
    V1EnvironmentsListEnvironmentVariablesRequestBody,
): string {
  return JSON.stringify(
    V1EnvironmentsListEnvironmentVariablesRequestBody$outboundSchema.parse(
      v1EnvironmentsListEnvironmentVariablesRequestBody,
    ),
  );
}
